import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import "react-quill/dist/quill.snow.css";
import store from "app/store";
import "./index.css";
import { IntlProvider } from "react-intl";
import Wrapper from "./components/Wrapper";
import GlobalSpinner from "./features/CommonComponents/GlobalSpinner/GlobalSpinner";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    {/* Redux Provider is included to access the store values from anywhere inside the child components. */}
    <Wrapper>
      <Provider store={store()}>
        <GlobalSpinner appContainer={<App />}></GlobalSpinner>
      </Provider>
    </Wrapper>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
